import React from "react";
import PropTypes from "prop-types";

const TwoUsersIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M12.0007 14.0003C12.0007 11.0568 9.61086 8.66699 6.66732 8.66699C3.72377 8.66699 1.33398 11.0568 1.33398 14.0003"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 5.33333C3.33398 7.17305 4.8276 8.66667 6.66732 8.66667C8.50703 8.66667 10.0007 7.17305 10.0007 5.33333C10.0007 3.49362 8.50703 2 6.66732 2C4.8276 2 3.33398 3.49362 3.33398 5.33333V5.33333"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6659 13.3335C14.6659 11.0868 13.3326 9.00013 11.9992 8.00013C12.8893 7.33234 13.3875 6.26444 13.3272 5.15333C13.267 4.04222 12.6563 3.03444 11.6992 2.4668"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

TwoUsersIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

TwoUsersIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default TwoUsersIcon;
